import { computed, isRef } from 'vue';
export const useComputedCallback = (value) => value instanceof Function
    ? computed(value)
    : isRef(value)
        ? value
        : computed(() => value);
